import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ja from './locales/ja.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            ja: { translation: ja },
        },
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        detection: {
            // A manual language choice must survive a reload.
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
        }
    });

// Keep <html lang> in sync so screen readers, hyphenation and Japanese
// phrase-aware line breaking (word-break: auto-phrase) use the right language.
const syncHtmlLang = () => {
    // resolvedLanguage is the language actually rendered (falls back when a
    // visitor's locale has no translation bundle).
    const lng = i18n.resolvedLanguage || i18n.language || 'en';
    document.documentElement.lang = lng.slice(0, 2);
};

i18n.on('languageChanged', syncHtmlLang);
i18n.on('initialized', syncHtmlLang);
if (i18n.isInitialized) syncHtmlLang();

export default i18n;
